<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
    >
      <v-card outlined>
        <v-card-text>
          <h3>Total items : {{ outOfStockItems }}</h3>
          <v-col cols="12">
            <v-select
              v-model="filter.product"
              :items="products"
              hide-details="auto"
              item-text="name"
              item-value="id"
              label="Select spacific product"
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="filter.warehouse"
              :items="warehouses"
              item-text="name"
              hide-details="auto"
              item-value="id"
              label="Select spacific warehouse"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="filter.threshHold"
              max="750"
              hide-details="auto"
              label="Quantiy less then"
              type="number"
              required
            />
          </v-col>
          <v-col cols="12">
            <v-btn @click="getOutOfStockItems">
              Load
            </v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="8"
    >
      <v-card outlined>
        <v-card-text v-if="outOfStockItems > 0">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Item
                  </th>
                  <th class="text-left">
                    Remaining Quantity
                  </th>
                  <th>Warehouse</th>
                  <th>Rack #</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in outOfStocks"
                  :key="item.name"
                >
                  <td>{{ item.product.name }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.warehouse.name }}</td>
                  <td>{{ item.rackNumber }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text v-else>
          <v-alert
            icon="mdi-shield-lock-outline"
            prominent
            text
            type="info"
          >
            There is nothing out of stock ! .
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      products: [],
      warehouses: [],
      filter: {
        product: "",
        warehouse: "",
        threshHold: 200,
      },
      outOfStocks: {},
    };
  },
  computed: {
    outOfStockItems() {
      return this.$data.outOfStocks.length;
    },
  },
  mounted() {
    this.getBasicData();
  },
  methods: {
    getBasicData() {
      window.axios.get("/product-form-data").then((response) => {
        this.warehouses = response.data.warehouses;
        this.products = response.data.products;
      });
    },
    getOutOfStockItems() {
      window.axios.post("/out-of-stock", this.$data.filter).then((response) => {
        this.$data.outOfStocks = response.data.list;
      });
    },
  },
};
</script>
